import "core-js/modules/es6.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { generateOpacityHex, getHexOpacityFromPercentage } from "../store/helpers/utility";
import { colorLuminance } from "../utils/utils";
export default {
  name: 'FibButton',
  props: {
    align: {
      type: String,
      default: 'center'
    },
    label: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
    to: {
      type: String,
      default: null
    },
    href: {
      type: String,
      default: null
    },
    outline: {
      type: Boolean,
      default: false
    },
    outlineBaseTheme: {
      type: Boolean,
      default: false
    },
    disable: {
      type: Boolean,
      default: false
    },
    inverse: {
      type: Boolean,
      default: false
    },
    round: {
      type: Boolean,
      default: false
    },
    flat: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: undefined
    },
    iconRight: {
      type: String,
      default: undefined
    },
    full: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: null,
      required: false
    },
    danger: {
      type: Boolean,
      default: false
    },
    square: {
      type: Boolean,
      default: false
    },
    animateOnPress: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    useBaseTheme: {
      type: Boolean,
      default: false
    },
    useAccentColor: {
      type: Boolean,
      default: false
    },
    discreet: {
      type: Boolean,
      default: false
    },
    itemCount: {
      type: Number,
      default: 0
    },
    noStyledSvg: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    theme: function theme() {
      if (this.useBaseTheme) {
        return this.$store.getters['theme/baseTheme'];
      }

      return this.$store.getters['theme/theme'];
    },
    buttonStyle: function buttonStyle() {
      if (this.flat) {
        return {
          color: this.color || this.theme.secondaryColor,
          border: 0
        };
      } else if (this.danger) {
        if (this.outline) {
          return {
            color: this.theme.dangerColor,
            borderColor: this.theme.dangerColor
          };
        }

        return {
          color: 'white',
          backgroundColor: this.theme.dangerColor,
          border: 0
        };
      } else if (this.outline) {
        var useColour = this.theme.greyColor || this.color;
        var useBorderColour = colorLuminance(this.theme.greyColor, 0.4) || this.color;
        return {
          color: this.outlineBaseTheme ? this.color : useColour,
          backgroundColor: 'transparent',
          borderColor: this.outlineBaseTheme ? this.color : useBorderColour
        };
      } else if (this.discreet) {
        return {
          backgroundColor: generateOpacityHex('#000000', 60),
          borderColor: generateOpacityHex('#000000', 60),
          color: this.color || '#ffffff'
        };
      } else if (this.inverse) {
        return {
          color: this.color || this.theme.greyColor,
          backgroundColor: 'white',
          border: '0',
          boxShadow: '0 6px 8px 0 rgba(0,0,0,.1)'
        };
      } else if (this.useAccentColor) {
        return {
          backgroundColor: this.theme.accentColor,
          borderColor: generateOpacityHex('#000000', 60),
          color: this.color || this.theme.secondaryColor
        };
      }

      return {
        color: this.disable ? colorLuminance(this.theme.greyColor, 0.75) : 'white',
        backgroundColor: this.color || this.disable ? colorLuminance(this.theme.greyColor, 0.24) : this.theme.secondaryColor,
        borderColor: this.disable ? colorLuminance(this.theme.greyColor, 0.6) : colorLuminance(this.theme.secondaryColor, -0.3)
      };
    },
    displayCount: function displayCount() {
      return this.itemCount > 99 ? '99+' : this.itemCount;
    }
  }
};